<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.fund')"
    :batch-actions="batchActions"
    resource="funds"
    :tabs="tabs"
  >
    <template slot="action">
      <bean-import-button
        can='funds.create'
        buttonText="导入"
        tooltipText="下载导入模板"
        url="/funds/import"
        loadingToast="导入中...请不要刷新页面"
        excelTemplateDownloadLink="/admin_api/v1/funds/import_template"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/funds.js';
import { formColumnsExtend as feeRateFCE, columnsExtend as feeRateCE } from '../admin_entities/fee_rate_detail.js';
import { columnsExtend as managementCE, formColumnsExtend as managementFCE } from '../admin_entities/management_detail.js';
import _ from 'lodash';

@Component
export default class Funds extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  get tabs() {
    return [{
      label: this.$t('model.user'),
      columns: this.columns(this.$createElement, { type: 'show' })
    }, {
      label: this.$t('fund.feeRate'),
      columns: feeRateCE(_.map([
        'allot_fee',
        'redeem_fee',
        'management_fee',
        'custodian_fee',
        'outsourcing_service_fee',
        'achievement_pay',
        'accrual_time',
      ], attr => ({ key: attr, prop: `fee_rate.${attr}` })))
    }, {
      label: this.$t('fund.management'),
      columns: managementCE(_.map([
        'open_day',
        'allot_day',
        'redeem_day',
        'transaction_process',
        'allot_threshold',
        'redeem_limit',
        'raise_account',
        'investment_scope',
      ], attr => ({ key: attr, prop: `management.${attr}` })))
    }]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'short_name',
      'code',
      'setup_date',
      'holders_count',
      {
        prop: 'revenue_datum.total_share',
        label: this.$t('revenueDatum.totalShare'),
        renderCell: 'money',
        width: 160,
      },
      {
        prop: 'revenue_datum.total_capital',
        label: this.$t('revenueDatum.totalCapital'),
        renderCell: 'money',
        width: 160,
      },
      'custodian',
      'early_warning',
      'risk_level',
      'closed_period',
      {
        key: 'visibility',
        width: 160,
      },
      type === 'show' && 'allot_process',
      'allot_trade_rule',
      'redeem_trade_rule',
      type === 'show' && 'total_scale',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'short_name',
      'code',
      'setup_date',
      'custodian',
      'early_warning',
      'risk_level',
      'closed_period',
      'visibility',
      'total_scale',
      'allot_trade_rule_id',
      'redeem_trade_rule_id',
      {
        key: 'allot_process',
        renderCell: {
          hint: `${this.$t('suggestSize')}: TODO`,
        }
      },
      {
        prop: 'fee_rate',
        label: this.$t('fund.feeRate'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: feeRateFCE([
              'allot_fee',
              'redeem_fee',
              'management_fee',
              'custodian_fee',
              'outsourcing_service_fee',
              'achievement_pay',
              'accrual_time',
              ], { data: {}, type: type })
          }
        }
      },
      {
        prop: 'management',
        label: this.$t('fund.management'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: managementFCE([
              'open_day',
              'allot_day',
              'redeem_day',
              'transaction_process',
              'allot_threshold',
              'redeem_limit',
              'raise_account',
              'investment_scope',
              ], { data: {}, type: type })
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      !row.is_index && row.visibility !== 'invisible' && {
        component: 'confirmButton',
        props: {
          label: '关闭',
          type: 'danger',
          can: 'funds.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/funds/${row.id}/close`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_index && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'funds.edit', params: { id: row.id } }
        }
      },
      !row.is_index && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'funds.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
          await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/funds',
    name: 'funds.index',
    component: Funds,
    props: {
      type: 'index',
    }
  },
  {
    path: '/funds/new',
    name: 'funds.new',
    component: Funds,
    props: {
      type: 'new',
    }
  },
  {
    path: '/funds/:id',
    name: 'funds.show',
    component: Funds,
    props: {
      type: 'show',
    }
  },
  {
    path: '/funds/:id/edit',
    name: 'funds.edit',
    component: Funds,
    props: {
      type: 'edit'
    }
  }
]
</script>
